import { useEffect } from "react";

export function openAskbox() {
    if (typeof window === "undefined") return;
    window.Askbox?.open?.();
    window.Askbox?.focus?.();
}

export function useAskbox({ brain, desktopMount, openDesktop = true } = {}) {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "/widgets/askbox/askbox.js";
        script.async = true;
        script.dataset.brain = brain;
        if (desktopMount) script.dataset.desktopMount = desktopMount;
        if (openDesktop) script.dataset.openDesktop = "true";
        document.body.appendChild(script);

        return () => {
            window.Askbox?.destroy?.();
            script.remove();
        };
    }, [brain, desktopMount, openDesktop]);
}
